<template>
    <v-container fluid>
        <v-form v-model="valid">
            <v-card :elevation="0">
                <SupplierSelect v-model="machineModel.SupplierId" allowCreate externaledit class="my-5">
                </SupplierSelect>
                <MachineTypeSelect v-model="machineModel.MachineTypeId" allowCreate externaledit class="my-5">
                </MachineTypeSelect>
                <QTextField v-model="machineModel.Name" :rules=[requiredRule]
                    :label="$t('servicesystem.common_objects.machine.name')" externaledit class="my-5">
                </QTextField>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" :disabled="!valid" @click="create()">
                        {{ $t('servicesystem.common_objects.commonterms.create') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import MachineTypeSelect from '@/components/Inputs/EntityDropdowns/MachineTypeSelect2.vue';
import SupplierSelect from '@/components/Inputs/EntityDropdowns/SupplierSelect2.vue';
import QInputRuleMixin from "@/helpers/Mixins/QInputRuleMixin";

export default {
    name: 'NewMachineModelForm',
    props: {},
    components: {
        SupplierSelect,
        MachineTypeSelect
    },
    mixins: [QInputRuleMixin],
    data() {
        return {
            valid: false,
            machineModel: {
                SupplierId: null,
                MachineTypeId: null,
                Name: null,
            },
            createMachineModelLoading: false,
        };
    },

    methods: {
        create() {
            this.createMachineModelLoading = true;
            clientAPI.methods.createModel(this.machineModel)
                .then((response) => {
                    this.$emit('create', response.Id)
                })
                .finally(() => {
                    this.createMachineModelLoading = false;
                });
        },
    },
    computed: {},
};
</script>


<style lang='scss' scoped></style>